var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8983 0.4375H2.59803C1.93619 0.4375 1.30145 0.664676 0.833452 1.06905C0.365456 1.47343 0.102539 2.02188 0.102539 2.59375L0.102539 18.4062C0.102539 18.9781 0.365456 19.5266 0.833452 19.931C1.30145 20.3353 1.93619 20.5625 2.59803 20.5625H9.73359V13.7204H6.45825V10.5H9.73359V8.04547C9.73359 5.25357 11.6572 3.71141 14.6034 3.71141C16.0144 3.71141 17.4899 3.92883 17.4899 3.92883V6.66906H15.8642C14.2624 6.66906 13.7628 7.52797 13.7628 8.40889V10.5H17.3386L16.7667 13.7204H13.7628V20.5625H20.8983C21.5602 20.5625 22.1949 20.3353 22.6629 19.931C23.1309 19.5266 23.3938 18.9781 23.3938 18.4062V2.59375C23.3938 2.02188 23.1309 1.47343 22.6629 1.06905C22.1949 0.664676 21.5602 0.4375 20.8983 0.4375Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.57bb35aceef042179aa5f3828ebdca0f.svg";
export { ForwardRef as ReactComponent };